export default __webpack_public_path__ + "static/media/three_month@3x.867ef613.png";